import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getProjectApprovalPeriods,
  updateProjectApprovalPeriod
} from '../../api/project-approval-periods';

export interface ApprovalPeriod {
  value: number | null;
  workflowStepId: number;
}

export const getProjectApprovalPeriodsAsync = createAsyncThunk(
  'projectApprovalPeriods/getProjectApprovalPeriods',
  getProjectApprovalPeriods
);

export const updateProjectApprovalPeriodAsync = createAsyncThunk(
  'projectApprovalPeriods/updateProjectApprovalPeriod',
  updateProjectApprovalPeriod
);

export interface ProjectApprovalPeriod {
  id: number;
  value: number;
  projectId: number;
  workflowStepId: number;
  workflowStep: {
    id: number;
    name: string;
    order: number;
  };
}

interface ProjectApprovalPeriodState {
  data: ProjectApprovalPeriod[];
}

const initialState: ProjectApprovalPeriodState = {
  data: []
};

export default createSlice({
  name: 'projectApprovalPeriods',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getProjectApprovalPeriodsAsync.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
      }
    );
  }
});
